import { reactive } from 'vue';
import { doPayloadQuery } from '@/kernel/api';

export const state = reactive({
  user: null,
  organisation: null,
  isPresentingModal: false,
  hasAttemptedHydration: false
});

export const hydrateUser = async () => {
  const data = await doPayloadQuery('GET', '/user/me');

  state.hasAttemptedHydration = true;
  state.user = data?.user || null;
}

export const hydrateOrganisation = async (organisationId = null) => {
  if (!organisationId && !isSuperAdmin()) {
    organisationId = state.user?.organisation.id || null;
  }

  if (!organisationId) {
    state.organisation = null;
    return;
  }

  if (state.organisation?.id === organisationId) {
    return;
  }

  try {
    state.organisation = await doPayloadQuery('GET', `/organisation/${organisationId}`);
  } catch(e) {
    state.organisation = null;
  }
}

export const checkSession = async () => {
  const data = await doPayloadQuery('GET', '/user/me');
  return data?.user;
}

export const hasAttemptedHydration = () => {
  return state.hasAttemptedHydration;
}

export const isSuperAdmin = () => {
  return state.user?.isSuperAdmin === true;
}

export const getFullName = () => {
  return state.user?.name || '';
}

export const getEmailAddress = () => {
  return state.user?.email || '';
}

export const isAuthenticated = () => {
  return state.user !== null;
}

export const getOrganisationId = () => {
  if (!hasOrganisation()) {
    return null;
  }

  return state.organisation.id;
}

export const getOrganisationName = () => {
  if (!hasOrganisation()) {
    return null;
  }

  return state.organisation.name;
}

export const hasOrganisation = () => {
  return state.organisation !== null;
}

export const isPresentingModal = () => {
  return state.isPresentingModal;
}

export const presentModal = () => {
  state.isPresentingModal = true;
}

export const dismissModal = () => {
  state.isPresentingModal = false;
}

export const shouldShowSuperAdmin = () => {
  return !hasOrganisation() && isSuperAdmin();
}

export const shouldShowOrganisation = () => {
  return hasOrganisation();
}

export const isSuperAdminView = () => {
  return !hasOrganisation();
}

export const isOrganisationView = () => {
  return hasOrganisation();
}

export const getSessionName = () => {
  return getFullName();
}
